import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { IndexRouters } from "./router";
import Signin from "./views/common/auth/pages/sign-in";
import { persistAuthState } from "./store/utils/persist-auth-state";
import { Toaster } from "react-hot-toast";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Error404 from "./views/dashboard/errors/error404";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Signin />,
      errorElement: <Error404 />,
    },
    ...IndexRouters,
  ],
  { basename: process.env.PUBLIC_URL }
);

store.subscribe(() => {
  const { auth, channel, project } = store.getState();
  persistAuthState({ auth, channel, project });
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <>
    <Toaster position="top-center" reverseOrder={false} />
    <StrictMode>
      <Provider store={store}>
        <App>
          <RouterProvider
            router={router}
            fallbackElement={<>Loading...</>}
          ></RouterProvider>
        </App>
      </Provider>
    </StrictMode>
  </>
);
